import React from "react";
import { Alert, Form } from "react-bootstrap";
import { BiRightArrowAlt, BiSearch } from "react-icons/bi";
import useOutsideClick from "../hooks/useOutsideClick";

/**
 * SearchButton Component
 * 
 * Dropdown search input button with outside-click detection to close menu.
 * Displays search icon that toggles dropdown input field when clicked. Supports
 * custom placeholder text, onChange handler for input value, and onKeyDown handler
 * for search submission. Shows loading state during search operations. Includes
 * floating alert for error/status messages with close handler.
 * 
 * @param {string} className - CSS class for styling
 * @param {string} value - Current search input value
 * @param {Function} onChange - Handler for search input changes
 * @param {Function} onKeyDown - Handler for keyboard events (e.g., Enter to submit)
 * @param {string} placeholderText - Placeholder text for search input
 * @param {Function} handleAlertClose - Handler to dismiss alert
 * @param {boolean} showAlert - Flag to show/hide alert
 * @param {JSX.Element} message - Alert message content
 * @param {boolean} isLoading - Loading state flag during search
 * @param {Function} handleSubmit - Handler for search submission
 * @returns {JSX.Element} Dropdown search button with input field and alert
 */
const SearchButton = ({
  className,
  value,
  onChange,
  onKeyDown,
  placeholderText,
  handleAlertClose,
  showAlert,
  message,
  isLoading,
  handleSubmit,
}) => {
  const { ref, isOpen, toggleNav } = useOutsideClick();

  return (
    <span ref={ref} className={className + " shutdownfilterbuttons dropdown"}>
      <BiSearch
        onClick={!isLoading ? () => toggleNav() : () => { }}
        size={"1.2rem"}
        className={isLoading ? "disabled" : " "}
      />
      {isOpen ? (
        <div className="search-cont-2">
          <Form
            className="search-form formsearch"
            onSubmit={!isLoading ? handleSubmit : (e) => e.preventDefault()}
          >
            <Form.Group className="inputgroup"
              controlId="formSearch"
              style={{
                marginBottom: "0px",
                display: "flex",
                height: "35px",
              }}
            >
              <Form.Control
                className="search-input-2 inputbox"
                value={value}
                type="search"
                name="searchTerm"
                placeholder={placeholderText}
                onChange={onChange}
                onKeyDown={onKeyDown}
                required
                style={{ height: "100%" }}
              />
              <span
                type="submit"
                className="search-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                <BiRightArrowAlt />
              </span>
            </Form.Group>
          </Form>
          <Alert
            show={showAlert}
            variant="danger"
            onClose={handleAlertClose}
            dismissible
            className="search-alert-div"
          >
            {message}
          </Alert>
        </div>
      ) : null}
    </span>
  );
};

export default SearchButton;
